<script>
import { formatDate } from '@/utils/date';

export default {
  name: 'PromotionPeriod',

  functional: true,

  props: {
    start: {
      type: String,
      required: true,
    },

    promotionEnd: {
      type: String,
      required: false,
      default: null,
    },
  },

  render: (h, ctx) => {
    if (!ctx.props.promotionEnd) return null;

    const content = `${formatDate(ctx.props.start)} - ${formatDate(ctx.props.promotionEnd)}`;
    // eslint-disable-next-line no-underscore-dangle
    return ctx._v(content);
  },
};
</script>
